import React from 'react';
import "./header.css";
import { Link } from 'react-router-dom';


const brandmoSubdomainName= process.env.REACT_APP_BRANDMOSUBDOMAIN;
const brandmoId = process.env.REACT_APP_BRANDMOUSERID;
// Get subdomain (adjust if hosted on brandmo)
const hostname = window.location.hostname;
const subdomain =  hostname.includes(brandmoSubdomainName) ? brandmoSubdomainName : hostname.split('.')[0];

console.log("==========Header=============")
console.log(subdomain)
console.log(brandmoSubdomainName)
console.log("===========Header End============")



const HeaderWithoutLogin = ({isSidebar}) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const user_logo = user?.user_logo || 'logo.svg';


    const toggleSidebar = () => {
        isSidebar();
    };


    if (subdomain === brandmoSubdomainName ) {
        return ( <>
            <header className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                    <div className="logo">
                        <img
                            src={user_logo}
                            alt="Partner Logo"
                            onError={(e) => {
                                e.target.src = `https://bi-api.tecreo.io/uploads/user_logo/brand-mo-logo.png`;
                                e.target.alt = 'Image not available';
                            }}
                        />
                    </div>
                    <span className="header-toggle-icon" onClick={toggleSidebar}> &#9776; </span>
                </div>
            </header>
        </>
        )
      }else{

    return (
        <>
            <header className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                    <div className="logo">
                        <img
                            src={user_logo}
                            alt="Partner Logo"
                            onError={(e) => {
                                e.target.src = `../../../assets/images/partner_img/tecreo.svg`;
                                e.target.alt = 'Image not available';
                            }}
                        />
                    </div>
                </div>
                <div>
                    <Link to="/login" className="btn btn-primary px-4 py-2 fw-bold">
                        Login
                    </Link>
                </div>
            </header>
        </>
    )
}
}
export default HeaderWithoutLogin;
